import { BankOperationStatusesNew } from 'constants/bankOperationStatusesNew';

import { useMemo } from 'react';

import { useGetList } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { BankOperationStatus } from 'types/embedded/bankOperation';

export const useBankOperationStatuses = () => {
  const { watch } = useFormContext();

  const [requestView] = watch(['requestView']);
  const { data: statuses } = useGetList<BankOperationStatus>('bank_operation_statuses', {
    filter: { groups: ['reference'] },
  });

  const bankOperationStatuses = useMemo(() => {
    if (requestView === 'on_approval') {
      return statuses?.filter((status) => {
        return status.value === BankOperationStatusesNew.OnApproval;
      });
    }

    return statuses?.filter((status) => {
      return (
        status.value === BankOperationStatusesNew.Created ||
        status.value === BankOperationStatusesNew.OnApproval ||
        status.value === BankOperationStatusesNew.Rejected
      );
    });
  }, [statuses, requestView]);

  return { bankOperationStatuses };
};
